export const Footer = () => (
    <footer className="bg-blue-800 text-white text-center py-4 text-sm sm:text-base">
      © 2025 PSA | PrimeStar Swim Academy Ltd.| Developed by <a href="https://anorcinc.com" className="underline">Anorc Inc</a>
    </footer>
  );
  export default Footer;